import React, { useEffect, useRef } from "react";
import "./VirasatRestaurantPage.scss"
import MenuCard from "../../components/MenuCard/MenuCard";
import { sortByOrderAscending } from "../../helper/helper";
import { useSelector } from "react-redux";
import Carousel from "../../components/Carousel/Carousel";


const VirasatRestaurantPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const pages = useSelector((state) => state.companyData.pages)

    const page = pages.find((page) => page.PageId === "restaurant")
    const Components = page?.Components || []

    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatV2RestaurantPage-hero-header":
                return <div className="VirasatRestaurantPage-hero-header-cont">
                    <div className="VirasatRestaurantPage-hero-header">{component?.Props?.header}</div>
                    <div className="VirasatRestaurantPage-hero-subheader">{component?.Props?.subheader}</div>
                </div>
            default:
                return <div />
        }

    }
    const headerComponent = (headerComponents) => {
        return (
            <div className="VirasatRestaurantPage-hero" style={{
                backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${headerComponents?.Props?.bgSrc})`
            }}>
                <div className="VirasatRestaurantPage-hero-container">
                    <div className="VirasatRestaurantPage-hero-container-wrapper">
                        {sortByOrderAscending(headerComponents?.Components).map((component, key) => {
                            return (<div key={key}>
                                {getHeaderComponents(component)}
                            </div>)
                        })}
                    </div>
                </div>
            </div>
        )
    }
    const getBottomComponent = (component) => {
        switch (component.ID) {
            case "VirasatV2RestaurantMenu-header":
                return <div className="VirasatRestaurantPage-subheader">
                    <span className="VirasatRestaurantPage-subheader-sep" />{component?.Props?.header} <span className="VirasatRestaurantPage-subheader-sep" /></div>
            case "VirasatV2RestaurantPage-menus":
                return <div className="VirasatRestaurantPage-wrapper-menucontainer">
                    {component?.Data?.map((value, key) => {
                        return (
                            <MenuCard menu={value} key={key} />
                        )
                    })}
                </div>
            case "VirasatV2RestaurantPage-menus-images":
                return <Carousel images={component?.Data} />
            default:
                return <div />
        }

    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatV2RestaurantPage-hero":
                return headerComponent(component)
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatRestaurantPage" >
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
            <div className="VirasatRestaurantPage-wrapper">
                {sortByOrderAscending(Components).map((component, key) => {
                    return (<div key={key}>
                        {getBottomComponent(component)}
                    </div>)
                })}
            </div>
        </div>
    )
}
export default VirasatRestaurantPage